import slideModule1 from "./Slide/imageslideDefaultModuleProp.js";
import slideModule2 from "./Slide/videoslideDefaultModuleProp.js";
import slideModule3 from "./Slide/imageslideDefaultModuleProp.js";
import slideModule4 from "./Slide/videoslideDefaultModuleProp.js";
import slideModule5 from "./Slide/imageslideDefaultModuleProp.js";
import slideModule6 from "./Slide/videoslideDefaultModuleProp.js";

const sliderModule = {
  // other module props
  id: "2d702500-6274-430c-9dba-fb249a784819",
  config: {
    general: {
      template: {
        label: "16:9", // or "4:3", "1:1, "9:16"
        component: "SixteenToNine", // or "FourToThree", "OneToOne", "NineToSixteen"
      },
      paddings: {
        top: false,
        bottom: false,
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: false,
      moduleBackgroundColor: {
        label: "Color 1",
        value: "#ffffe",
      },
      textAlign: {
        label: "Left", // or Center
        value: "left", // or center
      },
      corners: {
        label: "Round", // or Square
        value: "round", // or square
      },
      showHeader: true,
      showBody: true,
      showButton: true,
      showDots: true,
      activeDotColor: {
        label: "Color 2",
        value: "#13bae7",
      },
      loopSlides: false,
    },
  },
  modules: [
    slideModule1,
    slideModule2,
    slideModule3,
    slideModule4,
    slideModule5,
    slideModule6,
  ],
};

export default sliderModule;
